import { reportsService } from '@/services';
import { downloadBlob } from '@/shared/utils/download-blob.util';
import { useMutation } from '@tanstack/react-query';

interface DownloadReceiptPdfParams {
  /** id_lancamento (nativo do i4pro). */
  receiptId: number;
  /** Número do recibo — só para nomear o arquivo. */
  receiptNumber?: number;
}

/**
 * Baixa o Recibo em PDF (2ª via) de um recibo (base64 → blob → download), via
 * erpws `ImprimirRecibo`. Espelha o fluxo do boleto (`useInstallmentBoleto`).
 */
export function useReceiptPdf() {
  return useMutation({
    retry: false,
    mutationFn: async ({
      receiptId,
      receiptNumber,
    }: DownloadReceiptPdfParams) => {
      const result = await reportsService.getReceiptPdf(receiptId);
      if (!result.success || !result.data?.pdfBase64) {
        throw new Error(result.error || 'Recibo não disponível para download.');
      }

      const byteChars = atob(result.data.pdfBase64);
      const bytes = new Uint8Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        bytes[i] = byteChars.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: 'application/pdf' });
      downloadBlob(blob, `recibo-${receiptNumber ?? receiptId}.pdf`);
    },
  });
}
